import { BrowserRouter, Route, Switch, Routes } from 'react-router-dom';
import LandingPage from './pages/LandingPage'; 
import PunishGame from './pages/PunishGame';
import NeutralGame from './pages/NeutralGame';
import EdgeguardGame from './pages/EdgeguardGame';
import VideoPage from './pages/VideoPage';
import Contact from './pages/Contact';
import Pricing from './pages/Pricing';
import Resources from './pages/Resources';
import LogIn from './pages/LogIn';
import Register from './pages/Register';
import ProfilePage from './pages/ProfilePage';
import Tutorials from './pages/Tutorials';
import Intro from './pages/Intro';
import FoundationIndex from './pages/FoundationIndex';
import EmailVerification from './pages/EmailVerification';
import Checkout from './pages/Checkout';
import Contributions from './pages/Contributions';
import Testing from './pages/Testing';
import NotFound from './components/errorPages/NotFound';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ConstructionPage from './pages/ConstructionPage';
import Support from './pages/Support';

function App() {
  return (
    <BrowserRouter>
      <Routes >
        <Route path="/" element={<LandingPage />} />
        {/* <Route path="/tutorials" element={<Tutorials />} /> */} {/* Temporary disabled until further notice */}
        <Route path="/tutorials/foundation" element={<FoundationIndex />} />
        {/* <Route path="/videos/introduction" element={<Intro />} />
        <Route path='/videos/punish-game' element={<PunishGame />} />
        <Route path='/videos/neutral-game' element={<NeutralGame />} />
        <Route path='/videos/edgeguard-game' element={<EdgeguardGame />} /> */}
        <Route path='/tutorials/foundation/video/:id' element={<VideoPage />} />
        {/* Future 2nd video route similar to above route */}
        {/* <Route path='/tutorials/characters/:matchup/video/:id' element={<VideoPlayer />} /> */}
        <Route path='/login' element={<LogIn />} />
        <Route path='/register' element={<Register />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/pricing/subscribe/:tier' element={<Checkout />} />
        <Route path='/pricing/contributions' element={<Contributions />} />
        <Route path='/resources' element={<Resources />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/verify" element={<EmailVerification />} />
        {/* <Route path="/testing" element={<Testing />} /> */}
        <Route path='/contact' element={<ConstructionPage />} />
        <Route path='/about' element={<ConstructionPage />} />
        <Route path='/privacy' element={<ConstructionPage />} />
        <Route path='/terms' element={<ConstructionPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/support" element={<Support />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
